import React from 'react'
import { navigate, StaticQuery, graphql } from 'gatsby'
import Helmet from 'react-helmet'
import Layout from '../../../../../components/Layout'
import { isCar } from '../../../../../../lib/category-matcher'
import ContentRedirect from '../../../../../components/ContentRedirect'
import qs from 'querystring'

import UsedVehicle from '../../../../../templates/used-vehicle'
import { getVehicleData } from '../../../../../lib/vehicle-data-retriever'

class VehicleRedirector extends React.Component {
  componentDidMount() {
    const { brand, model } = this.props.params
    const { vehicle } = this.props.serverData

    if (vehicle && vehicle._id) return

    const vehicles = this.props.data.allUsedVehicleCatfish.nodes

    // eslint-disable-next-line no-unused-vars
    const [_, first] = this.props.path.split('/')

    const category = isCar(first.slice(0, first.length - 1)) ? 'car' : 'van'

    const similarVehicle = vehicles.find((vehicle) => {
      return (
        vehicle.model.toLowerCase().includes(model) &&
        vehicle.brand.toLowerCase().includes(brand)
      )
    })

    const query = qs.stringify({
      brand,
      model: similarVehicle ? similarVehicle.model.toLowerCase() : ''
    })

    const path = `/${category}s/used?${query}`

    navigate(path, { replace: true })
  }

  render() {
    const { vehicle, previewId, brand } = this.props.serverData
    // eslint-disable-next-line no-unused-vars
    const [_, first] = this.props.path.split('/')

    const category = isCar(first.slice(0, first.length - 1)) ? 'car' : 'van'

    if (vehicle && vehicle._id) {
      return (
        <UsedVehicle
          {...this.props}
          preview={
            vehicle && vehicle.previewId && vehicle.previewId === previewId
          }
          data={{
            vehicle,
            brandLocations: this.props.data.locations,
            vehicleLocation: {
              edges: [
                {
                  node: vehicle.dealership
                }
              ]
            }
          }}
          category={category}
          pageContext={{
            onOffer: false,
            offer: null,
            locations: this.props.data.locations.edges.map(({ node }) => node),
            category,
            brand
          }}
        />
      )
    }
    return (
      <Layout location={this.props.location}>
        <Helmet title={`Retrieving Vehicle`} />
        <ContentRedirect title={'Retrieving Vehicle'} />
      </Layout>
    )
  }
}

const VehicleRedirectorWrapper = (props) => {
  const data = graphql`
    {
      allUsedVehicleCatfish {
        nodes {
          brand
          model
          category
        }
      }
      locations: allDealershipCatfish(sort: { shortName: ASC }) {
        edges {
          node {
            _id
            slug
            shortName
            liveChatProviderId
            calltracksNumber
            calltracksId
            newVehicleTelephoneNumber
            newVehicleTelephoneId
            usedVehicleTelephoneNumber
            usedVehicleTelephoneId
          }
        }
      }
    }
  `

  return (
    <StaticQuery
      query={data}
      render={(data) => <VehicleRedirector data={data} {...props} />}
    />
  )
}

export default VehicleRedirectorWrapper

export const getServerData = getVehicleData
